import { useContext } from 'react';
import { WorkflowContext } from "../../../context/WorkflowContextProvider";
import {Handle, Position, useReactFlow } from "@xyflow/react";
import SettingsIcon from '@mui/icons-material/Settings';
import CheckIcon from '@mui/icons-material/Check';

function WorkflowSampleDataNode({id, data}) {
    const context = useContext(WorkflowContext);
    const reactFlowInstance = useReactFlow();

    function handleShowSampleDataConfigurationClick() {
        let node = reactFlowInstance.getNode(id);
        context.setActiveEditeSampleDataNode(node);
    }

    function successfulTest(): string {
        let returnValue: string = '';
        if (!!context.testComplete.includes(id)) {
            returnValue = ' test-success'
        }

        if (!!context.testProcessing.includes(id)) {
            returnValue = ' test-processing'
        }

        if (!!context.testErrored.includes(id)) {
            returnValue = ' test-error';
        }

        return returnValue;
    }

    return (
        <div className={ "workflow-node sample-data " + id + " " + (successfulTest()) }>
            { (successfulTest() !== '') &&
                <div className={ successfulTest() + "-icon" } />
            }
            <Handle type="target" id="sample-data-node-target" position={Position.Top} >
                <span className="handle-label top" >{ "Input" }</span>
            </Handle>
            <div className="node__layout">
                <div className="layout__top">
                    <span className={ "sample-data-icon" }></span>
                </div>
                <div className="layout__middle">
                    <span className={ "label-span" }>
                        { (typeof data?.label === 'string' && data.label.length > 0) ? data.label : 'Sample Data Node' }
                    </span>
                </div>
                <div className="layout__bottom">
                    <span className="action-span nodrag" onClick={ handleShowSampleDataConfigurationClick }>
                        <SettingsIcon />
                    </span>
                </div>
            </div>
            <Handle type="source" id="sample-data-node-source" position={Position.Bottom} >
                <span className="handle-label bottom" >{ "Output" }</span>
            </Handle>
        </div>
    );
}

export default WorkflowSampleDataNode;